/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LiveboardCategoryLiveboardsInner
 */
export interface LiveboardCategoryLiveboardsInner {
    /**
     * 
     * @type {string}
     * @memberof LiveboardCategoryLiveboardsInner
     */
    id: string;
}

/**
 * Check if a given object implements the LiveboardCategoryLiveboardsInner interface.
 */
export function instanceOfLiveboardCategoryLiveboardsInner(value: object): value is LiveboardCategoryLiveboardsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function LiveboardCategoryLiveboardsInnerFromJSON(json: any): LiveboardCategoryLiveboardsInner {
    return LiveboardCategoryLiveboardsInnerFromJSONTyped(json, false);
}

export function LiveboardCategoryLiveboardsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LiveboardCategoryLiveboardsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function LiveboardCategoryLiveboardsInnerToJSON(json: any): LiveboardCategoryLiveboardsInner {
    return LiveboardCategoryLiveboardsInnerToJSONTyped(json, false);
}

export function LiveboardCategoryLiveboardsInnerToJSONTyped(value?: LiveboardCategoryLiveboardsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

